// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/demand_breakdown_mode_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { DemandBreakdownModeService } from "./demand_breakdown_mode_service_pb";

/**
 * ListDemandBreakdownModes returns the organization's whole list, area
 * ascending; within an area the demand-forecast scope's retailers in scope
 * order, then out-of-scope retailers that still have a setting.
 *
 * @generated from rpc bffuser.v1.DemandBreakdownModeService.ListDemandBreakdownModes
 */
export const listDemandBreakdownModes = DemandBreakdownModeService.method.listDemandBreakdownModes;

/**
 * SaveDemandBreakdownMode replaces the (area, retailer) setting with one
 * that is always in effect. FAILED_PRECONDITION with a
 * DemandBreakdownSaveErrorReason when the save is not allowed, ABORTED when
 * another user changed the setting first, INVALID_ARGUMENT for a note that
 * is too long.
 *
 * @generated from rpc bffuser.v1.DemandBreakdownModeService.SaveDemandBreakdownMode
 */
export const saveDemandBreakdownMode = DemandBreakdownModeService.method.saveDemandBreakdownMode;

/**
 * DeleteDemandBreakdownMode removes the (area, retailer) setting, so the
 * 一括想定 default applies again. ABORTED when another user changed or
 * deleted the setting first.
 *
 * @generated from rpc bffuser.v1.DemandBreakdownModeService.DeleteDemandBreakdownMode
 */
export const deleteDemandBreakdownMode = DemandBreakdownModeService.method.deleteDemandBreakdownMode;
